<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
        <Spinner v-if="isLoading"/>
        <div v-if="!isLoading && carData" :class="{'datatable-is-loading':vehicleIsLoading}">
          <Toolbar class="p-mb-4">
            <template #start>
              <div style="font-size: 1.4em; color: inherit">{{ $store.getters.isForkliftTenant ? $t('Equipment') : $t('Car') }}:
                <span>
                  {{ formatCarLabel(carData) }}
                </span>
              </div>
            </template>
            <template #end>
              <span class="p-d-inline-flex"
                    v-show="$store.getters.isModeratorOrHigher"
                    v-tooltip.bottom="billingActionTooltipOptions()">
                <Button :disabled="vehicleIsLoading || billingDataEditingLocked"
                        :loading="vehicleIsLoading"
                        :label="$t('Edit')"
                        icon="ti-pencil"
                        @click="editItem"
                        class="p-button-success p-button-raised p-mr-2"/>
              </span>
              <span class="p-d-inline-flex"
                    v-show="$store.getters.isAdminOrHigher"
                    v-tooltip.bottom="billingActionTooltipOptions()">
                 <Button :label="$t('Delete')"
                         class="p-button-raised p-button-warning"
                         icon="ti-trash"
                         :disabled="vehicleIsLoading || billingDataEditingLocked"
                         :loading="vehicleIsLoading"
                         @click="confirmItemDelete"/>
              </span>

            </template>
          </Toolbar>

          <TabMenu :model="tabMenuItems" class="p-p-1"/>
          <router-view @update-items="updateItems"
                       :car="carData"
                       :vehicleIsLoading="vehicleIsLoading"
                       @change-customer-status="changeCustomerStatus"/>

          <CarModal :visible="itemModal"
                    :showCustomerSelector="true"
                    :item="item"
                    @update-items="updateItems"
                    @close="closeItemModal"/>
        </div>
        <div v-else-if="!isLoading && !vehicleIsLoading && !carData" class="empty-page">{{ $t('No data available') }}</div>

        <ConfirmDeleteModal :visible="confirmItemDeleteModal"
                            :modalDataIsLoading="modalDataIsLoading"
                            @close="closeConfirmItemDeleteModal"
                            @delete-item="deleteItem"
                            :data="computedItemToDeleteData"/>
			</div>

		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import settings from '@/settings.js'
import constants from '@/constants'
import CarModal from '@/pages/vehicles/components/CarModal'
import showErrorsMixins from "@/mixins/showErrorsMixins";
import datatableMixins from "@/mixins/datatableMixins";
import formatMixins from "@/mixins/formatMixins";
import billingRestrictionsMixin from '@/mixins/billingRestrictionsMixin'

export default {
  mixins: [ showErrorsMixins, datatableMixins, formatMixins, billingRestrictionsMixin ],
  components: { CarModal },
	data() {
		return {
      vehicleIsLoading: false,
      routePath: '/vehicles',
      // itemToDelete: {},
      confirmItemDeleteModal: false,
      itemModal: false,
      item: null,
      // taxes: [],
      isLoading: true,
      carData: null,
      settings,
      tabMenuItems: [],
      constants
    }
	},
  watch: {
    // '$route'() {
    //   const route = this.$route.path.split('/')
    //   if (this.$route.path === '/login' || route.indexOf('vehicles') === -1 || route.indexOf(this.$route.params.uid) === -1) {
    //     return false
    //   }
    // },
    '$i18n.locale'() {
      if (this.carData) {
        this.generateTabMenu()
      }
    },
    '$store.state.firstLayerIsOpened'(value) {
      if (!value) {
        if (this.itemModal) {
          this.closeItemModal()
        }
        if (this.confirmItemDeleteModal) {
          this.closeConfirmItemDeleteModal()
        }
      }
    },
  },
  mounted() {
    // window.scrollTo(0, 0)
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.getPageData()
	},
  methods: {
    getPageData() {
      this.getCarData()
    },
    confirmItemDelete() {
      if (this.billingActionIsRestricted()) return

      if (!this.carData) return
      // this.itemToDelete = {...this.carData}
      this.confirmItemDeleteModal = true
      this.$store.commit('toggleFirstLayer', true)
    },
    async deleteItem() {
      if (this.billingActionIsRestricted()) return

      if (!this.carData?.id || !this.$store.getters.userCanGetData) return
      this.modalDataIsLoading = true
      this.dataTableIsLoading = true
      try {
        const { status, data } = await httpClient.post('car/delete', { id: this.carData.id })
        if (status === 200 && data?.success) {
          this.$toast.add({severity:'success', detail: this.$t('Data deleted'), life: this.settings.toastLife});
          this.closeConfirmItemDeleteModal()
          this.carData = null
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.modalDataIsLoading = false
        this.dataTableIsLoading = false
      }
    },
    closeConfirmItemDeleteModal() {
      // this.itemToDelete = {}
      this.confirmItemDeleteModal = false
      this.$store.commit('toggleFirstLayer', false)
    },
    editItem() {
      if (this.billingActionIsRestricted()) return

      if (!this.carData) return
      this.item = this.carData
      this.itemModal = true
      this.$store.commit('toggleFirstLayer', true)
    },
    updateItems() {
      this.getCarData(false)
    },
    closeItemModal() {
      this.itemModal = false
      if (this.$store.state.firstLayerIsOpened === true ) {
        this.$store.commit('toggleFirstLayer', false)
      }
      this.item = null
      this.submitted = false
    },
    generateTabMenu() {
      this.tabMenuItems = [
        {label: this.$t('General information'), icon: 'ti-info-alt', to: `/vehicles/${this.$route.params.uid}/overview`},
        {label: this.$t('Orders') + ` (${this.carData?.ordersCount || 0})`, icon: 'ti-hummer', to: `/vehicles/${this.$route.params.uid}/orders`},
        {label: this.$t('Estimates') + ` (${this.carData?.offersCount || 0})`, icon: 'ti-clipboard', to: `/vehicles/${this.$route.params.uid}/estimates`},
        {label: this.$t('Parts history') + ` (${this.carData?.goodsCount || 0})`, icon: 'ti-package', to: `/vehicles/${this.$route.params.uid}/parts-history`},
      ]
    },
    async getCarData(showSpinner = true) {
      if (!this.$route.params.uid) return
      if (!this.userCanGetData || this.vehicleIsLoading) return
      this.vehicleIsLoading = true
      this.isLoading = showSpinner
      const ctrl = this.setController?.('carData')
      try {
        const { status, data } = await httpClient({
          url: 'car/get-by-uid',
          method: 'post',
          params: {
            expand: 'creator,ordersCount,offersCount,goodsCount,customer.customerStatus,creationLocationName',
          },
          data: { uid: this.$route.params.uid },
          signal: ctrl?.signal
        })
        if (status === 200 && data && data.success && data.item) {
          this.carData = data.item
          this.generateTabMenu()
        } else {
          this.showUnknownError()
          this.carData = null
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.vehicleIsLoading = false
        this.isLoading = false
        if (this._abortors?.carData === ctrl) {
          this._abortors.carData = null
        }
      }
    },
	},
  computed: {
    computedItemToDeleteData() {
      if (!this.carData) return null
      return this.formatCarLabel(this.carData)
    },
  }
}
</script>